"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userFactory;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _mobx = require("mobx");

function userFactory(user) {
  var phone = (0, _isArray2.default)((0, _get2.default)((0, _mobx.toJS)(user), 'registrationRequest.phone')) ? null : (0, _get2.default)(user, 'registrationRequest.phone');
  return {
    id: (0, _get2.default)(user, '_id'),
    title: (0, _get2.default)(user, 'Title'),
    firstName: (0, _get2.default)(user, 'FirstName'),
    middleName: (0, _get2.default)(user, 'MiddleName'),
    lastName: (0, _get2.default)(user, 'LastName'),
    primaryEmail: (0, _get2.default)(user, 'email'),
    email: (0, _get2.default)(user, 'registrationRequest.email') || (0, _get2.default)(user, 'email'),
    role: (0, _get2.default)(user, 'role'),
    provider: (0, _get2.default)(user, 'provider'),
    hasVerifiedEmail: (0, _get2.default)(user, 'hasVerifiedEmail'),
    hasVerifiedPhone: (0, _get2.default)(user, 'hasVerifiedPhone'),
    hasVerifiedWhatsApp: (0, _get2.default)(user, 'hasVerifiedWhatsApp'),
    primaryPhone: (0, _get2.default)(user, 'phone'),
    phone: phone || (0, _get2.default)(user, 'phone'),
    whatsapp: (0, _get2.default)(user, 'whatsapp'),
    registrationRequest: (0, _get2.default)(user, 'registrationRequest'),
    registrationHistory: (0, _get2.default)(user, 'registrationHistory'),
    residentCountryId: (0, _get2.default)(user, 'residentCountryId'),
    birthDate: (0, _get2.default)(user, 'birthDate'),
    nationalityId: (0, _get2.default)(user, 'nationalityId'),
    gender: (0, _get2.default)(user, 'gender')
  };
}